import React from 'react';
export function Footer() {
  return <footer className="bg-primary-deep border-t border-accent/30 py-10 px-4 text-center" data-id="element-100" data-mp="32wd2qgad7ltj">
      <p className="text-sm text-white/60" data-id="element-101" data-mp="3ggty8ibanj58">
        © Automotive Technology Instructor Ready 2026 — All rights reserved.
      </p>
    </footer>;
}